/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelHubtranFieldList.ts              *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/ar/hubtran-field-list";

export class AutogenModelHubtranFieldList<RowType extends ModelRow> extends Endpoint<RowType, RowHubtranFieldListFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowHubtranFieldList extends ModelRow<RowHubtranFieldListFields> {
	constructor(values?: Partial<RowHubtranFieldListFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowHubtranFieldListFields {
	company_id: string;
	field_name: string;
	filter_field_name: string;
	filter_field_value: string;
	hubtran_trans_type: string;
	id: string;
	is_active: string;
	reference_field: string;
	table_name: string;
}

